var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.174801,
    height: 25.61677,
    viewBox: "0 0 28.1748 25.61677",
    fill: "none",
    id: "svg34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path41",
    style: {
      fill: "#41415a"
    },
    d: "M 2.6328125 0.25 C 2.5652942 0.24756671 2.4983914 0.24820388 2.4316406 0.25195312 C 2.3426396 0.25695212 2.2550933 0.26776813 2.1679688 0.28320312 C 1.122474 0.46842295 0.25 1.3820538 0.25 2.5253906 L 0.25 23.09375 C 0.25 24.656018 1.8808103 25.777096 3.3398438 25.224609 C 8.1106838 23.417588 11.76165 22.136231 15.732422 21.113281 C 14.259193 20.728123 12.795704 20.436238 11.265625 20.214844 C 8.5701536 21.054746 5.8213606 22.039956 2.5957031 23.261719 C 2.4454026 23.318629 2.3496094 23.252519 2.3496094 23.09375 L 2.3496094 2.5253906 C 2.3496094 2.3745657 2.4449324 2.30736 2.5917969 2.3554688 C 5.3649291 3.2638734 7.7702685 3.9971913 10.046875 4.6113281 C 10.514448 4.5584268 10.974162 4.5018616 11.427734 4.4394531 C 11.881307 4.3770447 12.32798 4.3091374 12.771484 4.2363281 C 13.214989 4.1635189 13.654428 4.0841036 14.091797 4 C 14.529166 3.9158964 14.965224 3.8267602 15.400391 3.7304688 C 11.694408 2.9882756 8.0458337 1.9322826 3.2441406 0.359375 C 3.0409145 0.29280352 2.8353673 0.25729986 2.6328125 0.25 z M 15.400391 3.7304688 C 15.805525 3.8116046 16.210699 3.8890632 16.619141 3.9628906 C 17.027582 4.0367181 17.438816 4.1067908 17.853516 4.1738281 C 18.268215 4.2408654 18.68742 4.3044689 19.111328 4.3652344 C 19.535236 4.4259998 19.964322 4.4840506 20.400391 4.5390625 C 22.159016 3.9964564 24.001272 3.3526771 26.025391 2.5820312 L 26.025391 22.744141 C 23.756599 21.697941 21.72009 20.862453 19.777344 20.185547 C 18.362857 20.473519 17.028462 20.779396 15.732422 21.113281 C 18.678255 21.883435 21.676529 23.027491 25.396484 24.755859 C 26.627809 25.328029 28.125 24.389741 28.125 23.023438 L 28.125 2.328125 C 28.125 1.0149662 26.74115 0.0756467 25.521484 0.54296875 C 21.63082 2.0338193 18.512453 3.0418479 15.400391 3.7304688 z M 15.400391 3.7304688 C 14.965224 3.8267602 14.529166 3.9158964 14.091797 4 C 13.654428 4.0841036 13.214989 4.1635189 12.771484 4.2363281 C 12.32798 4.3091374 11.881307 4.3770447 11.427734 4.4394531 C 10.974162 4.5018616 10.514448 4.5584268 10.046875 4.6113281 C 11.863813 5.1014648 13.60326 5.5182961 15.351562 5.859375 C 17.808803 6.3387618 20.306453 6.6892048 23.150391 6.9550781 C 23.258451 6.9651801 23.324219 7.0393271 23.324219 7.1386719 L 23.324219 17.246094 C 23.324219 17.338424 23.263149 17.409336 23.164062 17.425781 C 20.393595 17.885673 17.984939 18.384345 15.691406 18.960938 C 17.034065 19.292307 18.381966 19.699359 19.777344 20.185547 C 20.955094 19.945771 22.186219 19.717753 23.509766 19.498047 C 24.60248 19.316692 25.423828 18.361766 25.423828 17.246094 L 25.423828 7.1386719 C 25.423828 5.9614764 24.508643 4.9719992 23.345703 4.8632812 C 22.318657 4.767265 21.345262 4.658262 20.400391 4.5390625 C 19.964322 4.4840507 19.535236 4.4259998 19.111328 4.3652344 C 18.68742 4.3044689 18.268215 4.2408654 17.853516 4.1738281 C 17.438816 4.1067908 17.027582 4.0367181 16.619141 3.9628906 C 16.210699 3.8890632 15.805525 3.8116046 15.400391 3.7304688 z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19.777344,20.185547 c -1.395378,-0.486188 -2.743279,-0.89324 -4.085938,-1.22461 -1.50147,0.37747 -2.95837,0.796665 -4.425781,1.253907 1.530079,0.221394 2.993568,0.513279 4.466797,0.898437 1.29604,-0.333885 2.630435,-0.639762 4.044922,-0.927734 z",
    style: {
      fill: "#41415a"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1.3,2.5247281 c 0,-0.837637 0.821856,-1.428557 1.61787,-1.167804 8.06788,2.642824 12.99873,3.866804 20.32953,4.552144 0.6355,0.05941 1.1269,0.59048 1.1269,1.22875 V 17.245328 c 0,0.604 -0.4415,1.1178 -1.0374,1.2167 -7.8495,1.303 -12.72522,2.8859 -20.36956,5.7813 C 2.162673,24.548028 1.3,23.955028 1.3,23.094528 Z",
    fill: "url(#paint6_linear_842_527)",
    id: "path14",
    style: {
      fill: "none",
      stroke: "none"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs34"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_842_527",
    x1: 91.4384,
    y1: 11.0591,
    x2: 140.778,
    y2: 11.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6",
    id: "stop14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063",
    id: "stop15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640",
    id: "stop16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_842_527",
    x1: 91.4384,
    y1: 11.0591,
    x2: 140.778,
    y2: 11.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6",
    id: "stop17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063",
    id: "stop18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640",
    id: "stop19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_842_527",
    x1: 91.4384,
    y1: 11.0591,
    x2: 140.778,
    y2: 11.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6",
    id: "stop20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063",
    id: "stop21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640",
    id: "stop22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_842_527",
    x1: 91.4384,
    y1: 11.0591,
    x2: 140.778,
    y2: 11.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6",
    id: "stop23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063",
    id: "stop24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640",
    id: "stop25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_842_527",
    x1: 91.4384,
    y1: 11.0591,
    x2: 140.778,
    y2: 11.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6",
    id: "stop26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063",
    id: "stop27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640",
    id: "stop28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_842_527",
    x1: 22.215401,
    y1: 11.9182,
    x2: 8.4764299,
    y2: 12.0436,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0,-0.4853515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6",
    id: "stop29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F03063",
    id: "stop30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FF7640",
    id: "stop31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_842_527",
    x1: 25.3267,
    y1: 12.0409,
    x2: 0.35578501,
    y2: 9.0602798,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0,-0.4853515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6",
    id: "stop32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063",
    id: "stop33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640",
    id: "stop34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortal);
export default __webpack_public_path__ + "static/media/portal.309a4e462307a8e3813e04288f65c4d0.svg";
export { ForwardRef as ReactComponent };